import React, { useState, useEffect } from 'react';
import { Form, Button, message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { authenticate } from "../../../services/admin/adminService";
const { REACT_APP_OUTBOUND_MENU_ONLY_SHOW } = process.env;

const LoginPage = ({ errorMessage }) => {
  const showOutboundMenu = process.env.REACT_APP_OUTBOUND_MENU_ONLY_SHOW;
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();

  useEffect(() => {
    //auto login if comes from workflow 
    const paramValue = query.get('loginauto');
    if (paramValue === 'true') {
      navigate("/PossibleResponseGroup");
      // if (showOutboundMenu == 'hide' || showOutboundMenu == 'all') {
      //   navigate("/PossibleResponseGroup");
      // }
      // else {
      //   navigate("/WorkFlowManagement");
      // }
    }
  }, [query]);

  const handleSocialLogin = (platform) => {
    alert(`${platform} login coming soon!`);
  };

  const onFinish = async (values) => {
    try {
      const response = await authenticate(email, password);
      if (response && response.success && response.user != "") {
        sessionStorage.setItem('roleId', response.user.role);
        navigate("/PossibleResponseGroup");
        // if (showOutboundMenu == 'hide' || showOutboundMenu == 'all') {
        //   navigate("/PossibleResponseGroup");
        // }
        // else {
        //   navigate("/WorkFlowManagement");
        // }
      } else {
        message.error("Credentials mismatch");
      }
    } catch (error) {
      message.error("An error occurred during authentication");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div style={styles.body}>
      <div style={styles.version}>v3.0.0</div>

      <div style={styles.loginContainer}>
        <div style={styles.loginHeader}>
          <h1 style={styles.headerTitle}>ADMIN LOGIN</h1>
          <p style={styles.headerSubtitle}>Please sign in to continue</p>
        </div>

        <Form style={styles.loginForm}
          onfiinitialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}>
          {errorMessage && (
            <div style={{ ...styles.errorMessage, display: 'block' }}>
              {errorMessage}
            </div>
          )}

          <div style={styles.formGroup}>
            <label style={styles.label}>User Id</label>
            <input
              type="text"
              id="email"
              placeholder="Enter User Id"
              required
              style={styles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <i style={styles.icon}><img style={{ width: "18px", marginTop: "6px" }} src="https://cdn-icons-png.flaticon.com/512/8661/8661737.png"></img></i>
            {emailError && <div style={{ ...styles.errorMessage, display: 'block' }}>{emailError}</div>}
          </div>

          <div style={styles.formGroup}>
            <label htmlFor="password" style={styles.label}>Password</label>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              placeholder="Enter your password"
              required
              style={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <i
              style={styles.icon}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '👁️' : <img style={{ width: "18px", marginTop: "6px" }} src="https://cdn-icons-png.flaticon.com/512/3256/3256783.png" />}
            </i>
            {passwordError && <div style={{ ...styles.errorMessage, display: 'block' }}>{passwordError}</div>}
          </div>

          <div style={styles.formCheck}>
            <div style={styles.formCheckLeft}>
              <input
                type="checkbox"
                id="remember"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={styles.checkbox}
              />
              <label htmlFor="remember" style={styles.checkboxLabel}>Remember me</label>
            </div>
            <a href="/forgot-password" style={styles.forgotPassword}>Forgot Password?</a>
          </div>
          <Button style={styles.loginBtn} htmlType="submit" block>
            Log in
          </Button>

          {/* <div style={styles.socialLogin}>
            <div
              style={styles.socialBtn}
              title="Login with Google"
              onClick={() => handleSocialLogin('Google')}
            >
              G
            </div>
            <div
              style={styles.socialBtn}
              title="Login with Facebook"
              onClick={() => handleSocialLogin('Facebook')}
            >
              f
            </div>
            <div
              style={styles.socialBtn}
              title="Login with Twitter"
              onClick={() => handleSocialLogin('Twitter')}
            >
              t
            </div>
          </div> */}

          {/* <div style={styles.signupLink}>
            Don't have an account? <a href="/" style={styles.signupAnchor}>Sign up</a>
          </div> */}
        </Form>
      </div>
    </div>
  );
};

// Styles object
const styles = {
  body: {
    background: "#e7e2ff",
    height: 'calc(100vh - 120px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },
  version: {
    position: 'absolute',
    top: '12px',
    right: '16px',
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '12px',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    padding: '4px 8px',
    borderRadius: '12px',
  },
  loginContainer: {
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
    width: '380px',
    overflow: 'hidden',
    position: 'relative',
    animation: 'fadeIn 0.6s ease-out',
  },
  loginHeader: {
    //background: 'linear-gradient(to right, #4776E6, #8E54E9)',
    backgroundImage:' radial-gradient(circle at top right, rgba(0, 0, 0, 0.05) 150px, transparent 151px),    linear-gradient(to right, #4776E6, #8E54E9)',
    padding: '15px',
    textAlign: 'center',
    color: 'white',
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: '24px',
    marginBottom: '8px',
  },
  headerSubtitle: {
    fontSize: '14px',
    opacity: 0.85,
  },
  loginForm: {
    padding: '30px',
    backgroundImage: 'radial-gradient(circle at bottom left, rgba(0, 0, 0, 0.05) 150px, transparent 151px)',    
  },
  formGroup: {
    marginBottom: '20px',
    position: 'relative',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontSize: '14px',
    color: '#555',
    fontWeight: 500,
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '15px',
    transition: 'all 0.3s',
    backgroundColor: '#f9f9f9',
    boxSizing: 'border-box',
  },
  icon: {
    position: 'absolute',
    right: '12px',
    top: '39px',
    color: '#aaa',
    cursor: 'pointer',
  },
  formCheck: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  formCheckLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  checkbox: {
    marginRight: '8px',
  },
  checkboxLabel: {
    fontSize: '14px',
    color: '#555',
  },
  forgotPassword: {
    color: '#8E54E9',
    fontSize: '14px',
    textDecoration: 'none',
    transition: 'all 0.3s',
  },
  loginBtn: {
    background: 'linear-gradient(to right, #4776E6, #8E54E9)',
    color: 'white',
    border: 'none',
    padding: '14px',
    width: '100%',
    fontSize: '16px',
    fontWeight: 600,
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.3s',
    boxShadow: '0 5px 15px rgba(142, 84, 233, 0.3)',
  },
  socialLogin: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  socialBtn: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 8px',
    border: '1px solid #ddd',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  signupLink: {
    textAlign: 'center',
    marginTop: '30px',
    fontSize: '14px',
    color: '#555',
  },
  signupAnchor: {
    color: '#8E54E9',
    textDecoration: 'none',
    fontWeight: 600,
  },
  errorMessage: {
    color: '#e74c3c',
    fontSize: '14px',
    marginTop: '5px',
    display: 'none',
  }
};

export default LoginPage;